import script from "./ModalDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ModalDetail.vue?vue&type=style&index=0&id=14ec638e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ec638e"]])

export default __exports__